import { useEffect, useState } from "react";
import { GetStaff } from "../../../services/OiService";
import { usePowder } from "../redux/ReduxContext";


export interface OiPowderStaffData {
    selectedStaff: string[];
}

export default function OiPowderStaff() {
    const { state, dispatch } = usePowder();
    const [availableStaff, setAvailableStaff] = useState<string[]>([]);
    const [inputValue, setInputValue] = useState("");
    const [showDropdown, setShowDropdown] = useState(false);
    const [filteredStaff, setFilteredStaff] = useState<string[]>([]);

    useEffect(() => {
        const fetchStaff = async () => {
            try {
                const staffData = await GetStaff();
                if (staffData) {
                    setAvailableStaff(staffData);
                } else {
                    setAvailableStaff([]);
                }
            } catch (error) {
                console.error("Failed to fetch staff:", error);
                setAvailableStaff([]);
            }
        };
        fetchStaff();
    }, []);


    const handleStaffSelect = (staffMember: string) => {
        if (!state.taggedStaff.includes(staffMember)) {
            dispatch({ type: 'ADD_ARRAY_ITEM', payload: { field: 'taggedStaff', item: staffMember } });
        }
        setInputValue("");
        setShowDropdown(false);
    };

    const handleAddNewStaffMember = () => {
        const trimmedStaff = inputValue.trim();
        if (trimmedStaff && !state.taggedStaff.includes(trimmedStaff)) {
            dispatch({ type: 'ADD_ARRAY_ITEM', payload: { field: 'taggedStaff', item: trimmedStaff } });
            if (!availableStaff.includes(trimmedStaff)) {
                setAvailableStaff(prev => [...prev, trimmedStaff]);
            }
            setInputValue("");
            setShowDropdown(false);
        }
    };

    const onStaffFilterChange = (value: string) => {
        setInputValue(value);
        if (value.trim().length > 3) {
            setFilteredStaff(availableStaff.filter(staff => staff.toLowerCase().includes(value.toLowerCase())));
            setShowDropdown(value.length > 0);
        }
    }

    const handleNewStaffKeyPress = (e: React.KeyboardEvent) => {
        if (e.key === 'Enter') {
            e.preventDefault();
            if (filteredStaff.length > 0) {
                handleStaffSelect(filteredStaff[0]);
            } else {
                handleAddNewStaffMember();
            }
        } else if (e.key === 'Escape') {
            setShowDropdown(false);
            setInputValue("");
        }
    };

    const handleStaffRemove = (staffMember: string) => {
        dispatch({ type: 'DELETE_ARRAY_ITEM', payload: { field: 'taggedStaff', index: state.taggedStaff.findIndex(s => s === staffMember) } });
    }
    return (
        <div className="bg-white dark:bg-oi-dark-background p-4 mb-4 drop-shadow-md">
            <h6 className="mb-2 text-sm font-bold">Staff</h6>
            <div className="my-4 relative">
                <div className="flex gap-2">
                    <div className="relative flex-1">
                        <input
                            type="text"
                            list="staff-options"
                            placeholder="Type to search staff or add new..."
                            value={inputValue}
                            onChange={(e) => onStaffFilterChange(e.target.value)}
                            onKeyDown={handleNewStaffKeyPress}
                            className="h-12 w-full p-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 border bg-primary-light dark:bg-primary-dark border-gray-300 dark:border-gray-600 placeholder-gray-400"
                        />

                        <datalist id="staff-options">
                            {filteredStaff.map((staff, index) => (
                                <option key={index} value={staff} />
                            ))}
                        </datalist>
                        <button
                            className="absolute right-2 top-1/2 -translate-y-1/2 px-3 py-1 bg-oi-button-blue text-primary-light h-8 "
                            onClick={(e) => handleAddNewStaffMember()}
                        >
                            Add
                        </button>
                    </div>
                </div>
            </div>
            {state.taggedStaff.length > 0 && (
                <div className="mb-4">
                    <div className="flex flex-wrap gap-2">
                        {state.taggedStaff.map((staff, index) => (
                            <label
                                key={index}
                                className="flex items-center gap-2 cursor-pointer hover:bg-gray-100 dark:hover:bg-gray-700 p-2 rounded transition-colors"
                            >
                                <input
                                    type="checkbox"
                                    checked={state.taggedStaff.includes(staff)}
                                    onChange={() => handleStaffRemove(staff)}
                                    className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 focus:ring-2"
                                />
                                <span className="text-sm text-gray-700 dark:text-gray-300 select-none">
                                    {staff}
                                </span>
                            </label>
                        ))}
                    </div>
                </div>
            )}

        </div>
    );
};